import React from 'react';
import generateKvkkText from '../KVKK';

function KvkkModal({ onClose, name, company, email }) {
  const kvkkText = generateKvkkText({
    name,
    company,
    email,
    date: new Date().toLocaleDateString('tr-TR'),
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>KVKK Aydınlatma Metni ve Açık Rıza Beyanı</h2>
        <div
          className="agreement-text"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
            marginBottom: '1rem',
          }}
        >
          {kvkkText}
        </div>
        <button onClick={onClose} className="register-btn">
          Kapat
        </button>
      </div>
    </div>
  );
}

export default KvkkModal;
